import { Family } from './Family/Family';
import { ReplicationState } from './replicate';

export interface ReplicationStateSummary {
  operating: ReplicationState<unknown>[];
  notOperating: ReplicationState<unknown>[];
}

export function summarize(
  replicationStates: ReplicationState<unknown>[],
  families: Family[],
): ReplicationStateSummary {
  const familyStates = families.reduce((state, family) => {
    Object.values(family.members).forEach(member => {
      state.add(member.replicationState);
    });
    return state;
  }, new Set<ReplicationState<unknown>>());

  const summary = replicationStates.reduce<ReplicationStateSummary>(
    (state, replicationState) => {
      if (replicationState.isStopped()) {
        if (familyStates.has(replicationState)) {
          // Anything that's part of a `Family` will spend at least some of its time intentionally stopped,
          // so we'll consider them to be "operating".
          // TODO: rework all this when `Family` is permanent.  https://nutrien.atlassian.net/browse/MDP-8188
          state.operating.push(replicationState);
        } else {
          state.notOperating.push(replicationState);
        }
      } else {
        state.operating.push(replicationState);
      }
      return state;
    },
    {
      operating: [],
      notOperating: [],
    },
  );
  return summary;
}
